/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotTotalsByLanguageModel extends models.CopilotActivityBase {
    getFixupPrototypeFunction() { return CopilotTotalsByLanguageModel.fixupPrototype; }

    static newInstance(model: Partial<CopilotTotalsByLanguageModel>): CopilotTotalsByLanguageModel {
        let obj = Object.assign(new CopilotTotalsByLanguageModel(), model);
        CopilotTotalsByLanguageModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotTotalsByLanguageModel>): CopilotTotalsByLanguageModel {
        if (!model) return null;
        return CopilotTotalsByLanguageModel.newInstance(<CopilotTotalsByLanguageModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotTotalsByLanguageModel) {
        if (!obj) return;

        models.CopilotTotalsByLanguageModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotTotalsByLanguageModel): boolean {
        if (models.CopilotActivityBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotTotalsByLanguageModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Programming language (e.g. javascript)
     */
    language: string;

    /**
     * AI model name (e.g. gpt-4.1)
     */
    model: string;

}
